export var PREVIEW_TRANSITION_DURATION = 300;
export var PREVIEW_CLOSE_GAP_DURATION = 500;
export var DEFAULT_MIN_SCALE = 0.5;
export var SCALE_STEP = 0.25;
var pinchWheelRatio = 2.5;
export var WHEEL_ZOOM_SENSITIVITY = 1.5;
export var PINCH_ZOOM_SENSITIVITY = WHEEL_ZOOM_SENSITIVITY * pinchWheelRatio;
export var FIREFOX_ZOOM_SENSITIVITY = 30;
